import { connect } from 'react-redux';

import ActivityGroupList from './ActivityGroupList';

const mapStateToProps = ({ entities }) => ({
  activityGroups: Object.values(entities.activityGroups)
});

export default connect(mapStateToProps)(ActivityGroupList);



// WEBPACK FOOTER //
// ./src/components/ActivityGroupList/ActivityGroupListContainer.js